import { Box, Heading, Text, useBreakpointValue, VStack } from "@chakra-ui/react";
import { motion } from "framer-motion";
import CustomRankForm from "../components/forms/CustomRankForm";
import { useAccount } from "wagmi";

const MotionHeading = motion(Heading);

const CustomRankPage = ({ isUserHasKey }) => {
	const isMobile = useBreakpointValue({ base: true, md: false });
	const { isConnected } = useAccount();

	return (
		// <Layout>
		<Box padding={4} maxWidth="100%" mx="auto">
			<VStack align="center">
				<Heading
					fontSize="clamp(1.5em, 2.8vw, 2.4em)"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 1 }}
					textAlign={"center"}
					mb={!isMobile ? 4 : 1}
				>
					Check Custom Rank
				</Heading>
				<Text fontSize="lg" color={'gray.500'}>
					Enter the range for marks and badges to see your rank among users within that range.
				</Text>
				<Box w={isMobile ? '100%' : "700px"} pt={4}>
					<CustomRankForm isConnected={isConnected} isUserHasKey={isUserHasKey} />
				</Box>
			</VStack>
		</Box>
		// </Layout>
	);
}

export default CustomRankPage;
